import { APITypesV1 } from "@cur8/api-client";

export function isDermaFollowUp(
  medicalExams: APITypesV1.MedicalExam[] | undefined
): boolean {
  return (
    medicalExams?.some((exam) =>
      [
        APITypesV1.MedicalExam.Dermascope,
        APITypesV1.MedicalExam.FourMonthDermascope,
        APITypesV1.MedicalExam.Dermatologist,
      ].includes(exam)
    ) ?? false
  );
}
